import React from "react";

type Props = {
    theme: "light" | "dark";
    toggle: () => void;
};

export default function ThemeToggle({ theme, toggle }: Props) {
    return (
        <button
            className="theme-toggle-button"
            aria-label="Toggle theme"
            title={`Switch to ${theme === "light" ? "dark" : "light"} mode`}
            onClick={toggle}
            style={{
                background: "linear-gradient(135deg, color-mix(in srgb, var(--text-primary) 5%, transparent), color-mix(in srgb, var(--text-primary) 2%, transparent))",
                border: "1px solid color-mix(in srgb, var(--accent) 15%, transparent)",
                color: "var(--text-primary)",
                padding: "0.5rem 0.75rem",
                borderRadius: "12px",
                cursor: "pointer",
                fontSize: "1.5rem",
                fontWeight: "600",
                transition: "all 0.3s ease",
                whiteSpace: "nowrap",
                flexShrink: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}
            onMouseEnter={(e) => {
                e.currentTarget.style.background = "linear-gradient(135deg, color-mix(in srgb, var(--accent) 8%, transparent), color-mix(in srgb, var(--accent) 4%, transparent))";
                e.currentTarget.style.transform = "translateY(-2px)";
                e.currentTarget.style.boxShadow = "0 8px 16px color-mix(in srgb, var(--accent) 15%, transparent)";
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.background = "linear-gradient(135deg, color-mix(in srgb, var(--text-primary) 5%, transparent), color-mix(in srgb, var(--text-primary) 2%, transparent))";
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "none";
            }}
        >
            {theme === "light" ? "☀️" : "🌙"}
        </button>
    );
}
